import { createSlice, Dispatch } from "@reduxjs/toolkit";
import { AgentService } from "app/services";
import { errorMsg } from "app/utils/MessageUtils";
import { AgentTypes } from "app/types/service-types/AgentTypes";

interface GetAgentParams {
  id: string;
  onSuccess?: (agent: AgentTypes) => void;
  onError?: (err: unknown) => void;
}

export const getAgent =
  ({ id, onSuccess, onError }: GetAgentParams) =>
  async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));

      const res = await AgentService.getAgentById(id);
      const agent: AgentTypes = (res && "data" in res ? (res as any).data : res) as AgentTypes;

      dispatch(setAgent(agent));
      onSuccess?.(agent);
    } catch (err: any) {
      const message =
        err?.response?.data?.message ??
        err?.data?.message ??
        err?.message ??
        "Failed to load agent details.";

      errorMsg(message);          
      onError?.(err);
    } finally {
      dispatch(setLoading(false));
    }
  };

interface AgentSlice {
  agent: AgentTypes | null;
  loading: boolean;
}

const initialState: AgentSlice = {
  agent: null,
  loading: false,
};

const stateSlice = createSlice({
  name: "agent/agent",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setAgent: (state, action) => {
      state.agent = action.payload;
    },
  },
});

export const { setLoading, setAgent } = stateSlice.actions;
export default stateSlice.reducer;
